"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readStreamChunk = readStreamChunk;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function readStreamChunk(_x) {
  return _readStreamChunk.apply(this, arguments);
}

function _readStreamChunk() {
  _readStreamChunk = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(resp) {
    var reader;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = resp.body.getReader();
            return _context.abrupt("return", new ReadableStream({
              start: function start(controller) {
                function pump() {
                  return reader.read().then(function (_ref) {
                    var done = _ref.done,
                        value = _ref.value;

                    // When no more data needs to be consumed, close the stream
                    if (done) {
                      controller.close();
                      return false;
                    } // Enqueue the next data chunk into our target stream


                    controller.enqueue(value);
                    return pump();
                  });
                }

                return pump();
              }
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _readStreamChunk.apply(this, arguments);
}